import { Box, Button } from '@mui/material'
import React, { useLayoutEffect, useRef, useState } from 'react'
import GSBookingPage from './BookingPage/GSBookingPage'
import { useSearchParams } from 'react-router-dom'
import { useEffect } from 'react'
import GSDeliveryPage from './DeliveryPage/GSDeliveryPage'
import GSAutoTransactionPage from './AutoTransactionPage/GSAutoTransactionPage'
import { autoTransPageTabs, bookingPageTabs, deliveryPageTabs, GeneralSettingAllTabs } from './GSConstants'
import { findObjctByValueFromArrayOfObject } from '../../common/helper'
import GSReportsPage, { reportsPageTabWithId } from './ReportsPage/GSReportsPage'

import GSPartyMasterPage from './PartyMasterPage/GSPartyMasterPage'
import GSCrossingMasterPage from './CrossingMasterPage/GSCrossingMasterPage'
import GSWaybillFormatPage, { waybillFormatPageTabWithId } from './WaybillFormatPage/GSWaybillFormatPage'
import StandardRateMatrix, { standardRateTabs } from './StandardRateMatrix'
import useToken from '../../helpers/useTokens'
import ExpenseHeadsPage, { expenseHeadsPageTabWithId } from './ExpenseHeadsPage/ExpenseHeadsPage'
import { RouteMaster } from './RouteMaster'
import { SmsPolicy } from './smsPolicy'
const GeneralSettings = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const [contentView, setContentView] = useState(Number(searchParams.get('tab')) || '')
  const [allTabs, setAllTabs] = useState([])
  const { loginData } = useToken()
  const { BusCrsCheckSum } = loginData || {}
  const contentRef = useRef(null)
  useLayoutEffect(() => {
    if (!contentRef.current) return
    const rect = contentRef.current.getBoundingClientRect()
    const availableHeight = window.innerHeight - rect.top - 20
    contentRef.current.style.height = `${availableHeight}px`
  }, [contentView])
  const authentication = sessionStorage.getItem('authentication')
  let baseUrl = 'https://policies.mavenconnect.tech'
  if (window.location.origin.includes('mavenconnect.biz')) {
    baseUrl = 'https://policies.mavenconnect.biz'
  }
  const whatsappPolicyUrl = `${baseUrl}/?authentication=${authentication}&tab=Cargo`
  useEffect(() => {
    // if (contentView === '') {
      const allGSPagesActive = JSON.parse(sessionStorage.getItem('token1')) || [];
      const filterTabs = (tabs) => tabs.filter((item) => findObjctByValueFromArrayOfObject(allGSPagesActive, item.JobID, 'JobID', "IsActive") === 1 ? item : null);
      
      const bookTabData = filterTabs(bookingPageTabs);
      const delTabData = filterTabs(deliveryPageTabs);
      const autoTransaction=filterTabs(autoTransPageTabs)
      const partyMasterFlag = findObjctByValueFromArrayOfObject(allGSPagesActive,GeneralSettingAllTabs?.[3]?.JobID, 'JobID', "IsActive") === 1 ? true : false
      const crossingMasterFlag = findObjctByValueFromArrayOfObject(allGSPagesActive,GeneralSettingAllTabs?.[8]?.JobID, 'JobID', "IsActive") === 1 ? true : false
      const rateMatrixFlag = filterTabs(standardRateTabs)
      const wayBillFormatFlag = filterTabs(waybillFormatPageTabWithId)
      const expenseHeadsFlag = filterTabs(expenseHeadsPageTabWithId)
      
      const reportsConfigFlag = filterTabs(reportsPageTabWithId)
      const smsPolicyFlag = findObjctByValueFromArrayOfObject(allGSPagesActive,GeneralSettingAllTabs?.[10]?.JobID, 'JobID', "IsActive") === 1 ? true : false
      const allTab = [];
      if (bookTabData?.length > 0) allTab.push(GeneralSettingAllTabs[0]);
      if (delTabData?.length > 0) allTab.push(GeneralSettingAllTabs[1]);
      if(rateMatrixFlag?.length > 0)  allTab.push(GeneralSettingAllTabs[2]);
      if (partyMasterFlag) allTab.push(GeneralSettingAllTabs[3]);
      if (autoTransaction?.length > 0) allTab.push(GeneralSettingAllTabs[4]);
      if (reportsConfigFlag?.length > 0) allTab.push(GeneralSettingAllTabs[5]);
      if(wayBillFormatFlag?.length > 0) allTab.push(GeneralSettingAllTabs[6]);
      if (crossingMasterFlag) allTab.push(GeneralSettingAllTabs[7])
      if(expenseHeadsFlag?.length > 0) allTab.push(GeneralSettingAllTabs[8]);
      if(smsPolicyFlag) allTab.push(GeneralSettingAllTabs[10]);
      setAllTabs([...allTab])
      if(contentView === ''){
        goToTabs(allTab?.[0]?.JobID);
      }
    // }
  }, [searchParams])
  const params = {}
  for (let entry of searchParams.entries()) {
    params[entry[0]] = entry[1]
  }
  const goToTabs = (lrTab) => {
    params.tab = lrTab
    delete params.id
    setSearchParams(params)
    setContentView(lrTab)
  }

  const contentShow = (key) => {
    let GeneralSettingType
    switch (key) {
      case 1: {
        GeneralSettingType = <GSBookingPage />
        break
      }
      case 2: {
        GeneralSettingType = <GSDeliveryPage />
        break
      }
      case 3: {
        GeneralSettingType = <StandardRateMatrix/>
        break
      }
      case 51: {
        GeneralSettingType = <GSPartyMasterPage />
        break
      }
      case 5: {
        GeneralSettingType = <GSAutoTransactionPage />
        break
      }
      case 6: {
        GeneralSettingType = <GSReportsPage/>
        break
      }
      case 7: {
        GeneralSettingType = <GSWaybillFormatPage />
        break
      }
      case 47: {
        GeneralSettingType = <ExpenseHeadsPage/>
        break
      }
      case 256: {
        GeneralSettingType = <GSCrossingMasterPage/>
        break
      }
      case 585: {
        GeneralSettingType = <RouteMaster/>
        break
      }
      case 61: {
        GeneralSettingType = <SmsPolicy/>
        break
      }
      default:
        GeneralSettingType = ''
        break
    }
    return GeneralSettingType
  }

  const openBusMasterTab = () => {
    const busMasterUrl = `http://buscrs.com/MasterBus/BusMasterEXE?chk=${BusCrsCheckSum}`
    window.open(busMasterUrl, '_blank')
  }

  return (
    <>
      <Box className="generalSetting">
        {
          allTabs?.map((item, i) => {
            return (
              <Button key={i} className={`generalSettingBtn ${contentView == item.JobID ? 'active' : ''}`} variant="outlined" onClick={() => goToTabs(item.JobID)}>
                {item.name}
              </Button>
            )
          })
        }
        <Button className={`generalSettingBtn`} variant="outlined" onClick={openBusMasterTab}>
          Vehicle Master
        </Button>
        {/* <Button className={`generalSettingBtn ${contentView == 20000 ? 'active' : ''}`} variant="outlined" onClick={() => goToTabs(20000)}>
          WhatsApp Policy
        </Button> */}
      </Box>
      <Box>
        {contentShow(contentView)}
      </Box>
      {contentView === 20000 && (
        <iframe
          ref={contentRef}
          src={whatsappPolicyUrl}
          style={{
            width: '100%',
            border: 'none',
          }}
        />
      )}
    </>
  )
}

export default GeneralSettings

